import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
export function CostSection() {
  const costs = [{
    situation: '3 hs buscando prompts × 40 semanas',
    cost: '120 horas de tu vida por año'
  }, {
    situation: 'Copy armado sin framework',
    cost: 'Anuncios que no convierten + presupuesto quemado'
  }, {
    situation: 'Sin banco de ángulos',
    cost: 'Siempre el mismo mensaje, audiencia saturada'
  }, {
    situation: 'Sin sistema de diagnóstico',
    cost: 'Cambios al azar que destruyen el aprendizaje'
  }, {
    situation: 'Sin checklist de lanzamiento',
    cost: 'Errores técnicos que cuestan días de presupuesto'
  }, {
    situation: 'Sin planner semanal',
    cost: 'Caos operativo que frena el crecimiento'
  }];
  return <section className="py-12 px-4 max-w-4xl mx-auto" data-id="element-75">
      <FadeIn data-id="element-76">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-77">
          <span className="text-4xl" data-id="element-78">⚖️</span> ¿CUÁNTO CUESTA NO TENERLO?
        </h2>

        <div className="bg-gray-900 border border-gray-800 rounded-2xl overflow-hidden" data-id="element-79">
          <div className="grid grid-cols-2 bg-gray-800/80 border-b border-gray-700 p-4 font-bold" data-id="element-80">
            <div className="text-gray-400" data-id="element-81">Sin el MegaPack</div>
            <div className="text-red-400" data-id="element-82">Costo real</div>
          </div>

          <div className="divide-y divide-gray-800/50" data-id="element-83">
            {costs.map((item, index) => <div key={index} className="grid grid-cols-2 p-4 items-center hover:bg-gray-800/30 transition-colors" data-id="element-84">
                <div className="text-gray-300 pr-4 text-sm md:text-base" data-id="element-85">
                  {item.situation}
                </div>
                <div className="font-bold text-red-400 flex items-center gap-2 text-sm md:text-base" data-id="element-86">
                  <AlertOctagon size={16} className="shrink-0" data-id="element-87" />
                  <span data-id="element-88">{item.cost}</span>
                </div>
              </div>)}
          </div>
        </div>
      </FadeIn>
    </section>;
}